<template>
  <div class="pt-panel submerg-panel">
    <div v-if="scenario" class="pt-section">
      <div class="pt-section-title">
        <strong>{{ scenario.scenario_name }}</strong>
      </div>
      <div class="pt-info-row" style="flex-direction: column; gap: 4px;">
        <div><strong>洪峰流量：</strong>{{ scenario.metrics.peak_flow }} m³/s</div>
        <div><strong>最高水位：</strong>{{ scenario.metrics.max_stage }} m</div>
        <div><strong>最大淹没：</strong>{{ scenario.metrics.max_inundation_area_km2 }} km²</div>
        <div><strong>风险等级：</strong>{{ scenario.metrics.risk_level }}</div>
        <div><strong>影响对象：</strong>{{ scenario.metrics.impacted_count }} 个</div>
        <div style="color: #ffd166; margin-top: 4px;"><strong>预案：</strong>{{ scenario.recommended_plan.name }}</div>
      </div>
    </div>

    <div class="pt-section" style="display: flex; gap: 8px; flex-wrap: wrap;">
      <button class="pt-btn" @click="clear()">结束预演</button>
      <button class="pt-btn pt-btn-success" @click="openEmergencyPlan()">打开预案</button>
      <button class="pt-btn" @click="back()">返回水库</button>
    </div>
  </div>
</template>

<script>
import * as Cesium from 'cesium'
import SubmergenceAnalysis from "@/utils/submergAnalysis";
import {protection} from "@/common/js/position";
import DynamicRange from "@/utils/dynamicRange";
import DragEntity from "@/utils/dragentity";

export default {
  name: "SubmergAnalysis",
  data() {
    return {
      height_max: '',
      height_min: 452,
      speed: 0.7,
      level: 2050,
      map_type: true,
      rangeList: [],
      defendList: [],
      scenario: null,
    };
  },

  methods: {
    start(val) {
      this.defend = val.defend
      this.scenario = val.item && val.item.floodScenario ? val.item.floodScenario : null
      this._initViewStatus(window.viewer);

      if (this.scenario && this.scenario.frames && this.scenario.frames.length) {
        this.height_min = Math.min(...this.scenario.frames.map(frame => frame.stage))
        this.height_max = Math.max(...this.scenario.frames.map(frame => frame.stage))
      } else if (val.item.num == 1) {
        this.height_max = 462
      } else if (val.item.num == 2) {
        this.height_max = 460
      } else if (val.item.num == 3) {
        this.height_max = 458
      } else {
        this.height_max = val.item.height_max
      }

      let Range = new DynamicRange({ viewer: window.viewer })
      let drag = new DragEntity({ viewer: window.viewer })

      this.defend.forEach(e => {
        protection.forEach(item => {
          if (e.name == item.name) {
            let entity = drag.addEntity(item);
            this.defendList.push(entity)
            if ((item.name == '农田' && this.height_max > 460) || (item.name == '居民区' && this.height_max > 458)
                || (item.name == '工业区' && this.height_max >= 431)) {
              let dynamicRange = Range.dynamicRange({
                item: item,
                minR: 0,
                maxR: 100,
                deviationR: 2,
              });
              this.rangeList.push(dynamicRange)
            }
          }
        })
      })

      this.obj = new SubmergenceAnalysis(
          window.viewer,
          true,
          this.height_max,
          this.height_min,
          this.speed,
          this.map_type,
          this.scenario
      );

      this.obj.start();
    },

    clear(emitClose = true) {
      this.defendList.forEach(item => {
        window.viewer.entities.remove(item)
      })
      this.rangeList.forEach(item => {
        window.viewer.entities.remove(item)
      })
      this.obj && this.obj.clear();
      this.scenario = null
      this.defendList = []
      this.rangeList = []
      if (emitClose) this.$emit('close')
    },
    _initViewStatus(viewer) {
      var scene = viewer.scene;
      scene.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(110.352214, 35.503038, 630.1647044280788),
        orientation: {
          heading: 4.309753365050971,
          pitch: -0.18985055881264024,
          roll: 6.280214189434832
        }
      });
    },
    riverLevel() {
      this.$emit('initLevel', this.level)
    },
    openEmergencyPlan() {
      const planName = this.scenario && this.scenario.recommended_plan
          ? this.scenario.recommended_plan.name
          : '水库防汛应急预案'
      this.clear(false)
      this.$emit('openEmergencyPlan', planName)
    },
    back() {
      this.clear(false)
      window.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(110.319074, 35.537171, 1352.3042078907017),
        orientation: {
          heading: 4.073307009772927,
          pitch: -0.3676531544625212,
          roll: 6.280457769978864
        }
      })
      this.$emit('back')
    }
  },
};
</script>

<style scoped>
.submerg-panel {
  position: absolute;
  top: 8%;
  right: 25%;
  width: auto;
  height: auto;
  min-width: 260px;
  padding: 14px;
}
</style>
